<div class="container single-view" id="view-customer">
  <div class="row">
    <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
      <div id="pre-header-wr">
        <a data-testid="back-btn" href="javascript:void(0)" appBack fallbackUrl="/customers" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'CUSTOMERS.BTN_BACK_TO_CUSTOMER' | translate }}</a>
      </div>
    </div>
    <div class="col-12">
      <div id="view-header-wr" class="flex flex-wrap items-end justify-between gap-4">
        <div class="title-wr flex flex-wrap items-center">
          <div data-testid="customer-item">
            <h1 data-testid="section-item" class="section-title mb-3">{{ 'CUSTOMER_SINGLE_VIEW.CUSTOMER_DETAILS' | translate }}</h1>
            <div>
              <h2 data-testid="element-item" class="element-title flex items-center gap-2">
                <span data-testid="customer-name">{{ (customer.firstName || customer.romanisedFirstName) | defaultValue }} {{ (customer.lastName || customer.romanisedLastName) | defaultValue }}</span>
              </h2>
            </div>
          </div>
        </div>
        <div class="w-100 flex flex-wrap justify-between gap-y-4 self-end">
          <div id="complementary-details" class="flex flex-wrap">
            <span data-testid='customer-mail' class="flex items-center mr-3" pTooltip="{{ 'CUSTOMER_SINGLE_VIEW.TOOLTIP_EMAIL' | translate }}" tooltipPosition="top"><i class="icon icon-email mr-1"></i>{{ customer.email | defaultValue }}</span>
            <span data-testid='customer-since' class="flex items-center mr-2"
              pTooltip="{{ 'CUSTOMER_SINGLE_VIEW.TOOLTIP_CUSTOMER_SINCE' | translate }}" tooltipPosition="top"><i class="icon icon-calendar mr-1"></i>{{ customer.createdOn | date: 'dd-MM-yyyy HH:mm' | defaultValue }}</span>
          </div>
          <div id="actions-wr" class="flex flex-wrap items-stretch justify-end gap-3">
            @if (allowModifyCustomer) {
              <button data-testid="customer-edit-btn" [disabled]="customer.isAnonymised" class="btn primary-btn" (click)="goToEditCustomer()">
                {{ 'CUSTOMER_SINGLE_VIEW.BTN_EDIT' | translate }}
              </button>
            }
            @if (delete) {
              <button data-testid="customer-delete-btn" [disabled]="customer.isAnonymised" class="btn red-btn" (click)="dialog.show()">
                {{ 'CUSTOMERS.BTN_DELETE' | translate }}
              </button>
            }
          </div>
        </div>
      </div>
      <hr role="presentation" class="w-full mb-3 mt-6 border-t">
      <div class="view-content-wr">
        <div class="row">
          <div class="flex flex-col col-12 mb-2 text-wr">
            <!-- main content -->
            <section class="row">
              <div class="col-12">
                <h4 data-testid="customer-details">{{ 'CUSTOMER_SINGLE_VIEW.DETAILS' | translate }}</h4>
                <hr role="presentation" class="w-full mb-2 mt-3 border-t">
                <dl class="details-grid">

                  <dt data-testid="customer-firstname-label" class="label grid-cols-1 pt-3">{{ 'CUSTOMER_SINGLE_VIEW.FIRST_NAME' | translate }}</dt>
                  <dd data-testid="customer-firstname" class="value pt-3 pb-3">{{ customer.firstName | defaultValue }}</dd>

                  <dt data-testid="customer-romanisedfirstname-label" class="label grid-cols-1 pt-3">{{ 'CUSTOMER_SINGLE_VIEW.ROMANIZED_FIRST_NAME' | translate }}</dt>
                  <dd data-testid="customer-romanisedfirstname" class="value pt-3 pb-3">{{ customer.romanisedFirstName | defaultValue }}</dd>

                  <dt data-testid="customer-lastname-label"  class="label grid-cols-1 pt-3">{{ 'CUSTOMER_SINGLE_VIEW.LAST_NAME' | translate }}</dt>
                  <dd data-testid="customer-lastname" class="value pt-3 pb-3">{{ customer.lastName | defaultValue }}</dd>

                  <dt data-testid="customer-romanisedlastname-label" class="label grid-cols-1 pt-3">{{ 'CUSTOMER_SINGLE_VIEW.ROMANIZED_LAST_NAME' | translate }}</dt>
                  <dd data-testid="customer-romanisedlastname" class="value pt-3 pb-3">{{ customer.romanisedLastName | defaultValue }}</dd>

                  <dt data-testid="customer-gender-label" class="label grid-cols-1 pt-3">{{ 'CUSTOMER_SINGLE_VIEW.GENDER' | translate }}</dt>
                  <dd data-testid="customer-gender" class="value pt-3 pb-3">{{ customer.gender | gender | defaultValue }}</dd>

                  <dt data-testid="customer-email-label" class="label grid-cols-1 pt-3">{{ 'CUSTOMER_SINGLE_VIEW.EMAIL' | translate }}</dt>
                  <dd data-testid="customer-email" class="value pt-3 pb-3">{{ customer.email | defaultValue }}</dd>

                  <dt data-testid="customer-birthdate-label" class="label grid-cols-1 pt-3">{{ 'CUSTOMER_SINGLE_VIEW.BIRTHDATE' | translate }}</dt>
                  <dd data-testid="customer-birthdate" class="value pt-3 pb-3">{{ customer.birthDate | date: 'dd-MM-yyyy' | defaultValue }}</dd>

                  <dt data-testid="customer-foreign-label" class="label grid-cols-1 pt-3">{{ 'CUSTOMER_SINGLE_VIEW.IS_FOREIGN' | translate }}</dt>
                  <dd data-testid="customer-foreign" class="value pt-3 pb-3">{{ customer.foreign | friendlyBoolean }}</dd>

                  <dt data-testid="customer-country-label" class="label grid-cols-1 pt-3">{{ 'CUSTOMER_SINGLE_VIEW.COUNTRY' | translate }}</dt>
                  <dd data-testid="customer-country" class="value pt-3 pb-3">{{ customer.isoCountry | CountryTransformPipe | async | defaultValue }}
                  </dd>

                  <dt data-testid="customer-address-label" class="label grid-cols-1 pt-3">{{ 'CUSTOMER_SINGLE_VIEW.ADDRESS' | translate }}</dt>
                  <dd data-testid="customer-address" class="value pt-3 pb-3">{{ customer.address | defaultValue }}</dd>

                  <dt data-testid="customer-postalcode-label" class="label grid-cols-1 pt-3">{{ 'CUSTOMER_SINGLE_VIEW.POSTAL_CODE' | translate }}</dt>
                  <dd data-testid="customer-postalcode" class="value pt-3 pb-3">{{ customer.postalCode | defaultValue }}</dd>

                  <dt data-testid="customer-wantemails-label" class="label grid-cols-1 pt-3">{{ 'CUSTOMER_SINGLE_VIEW.WANT_EMAILS' | translate }}</dt>
                  <dd data-testid="customer-wantemails" class="value pt-3 pb-3">{{ customer.wantEmails | friendlyBoolean }}</dd>

                  <dt data-testid="customer-acceptterms-label" class="label grid-cols-1 pt-3">{{ 'CUSTOMER_SINGLE_VIEW.TOS_ACCEPTED' | translate }}</dt>
                  <dd data-testid="customer-acceptterms" class="value pt-3 pb-3">{{ customer.acceptedTerms | friendlyBoolean }}</dd>

                  <dt data-testid="customer-acceptprivacypolicy-label" class="label grid-cols-1 pt-3">{{ 'CUSTOMER_SINGLE_VIEW.PRIVACY_POLICY_ACCEPTED' | translate }}</dt>
                  <dd data-testid="customer-acceptprivacypolicy" class="value pt-3 pb-3">{{ customer.acceptedPrivacyPolicy | friendlyBoolean }}</dd>
                  </dl>
              </div>
            </section>
            <section class="row">
              <div class="col-12 mb-3">
                <h4 data-testid="customer-sales">{{ 'CUSTOMER_SINGLE_VIEW.SALES' | translate }}</h4>
                <hr role="presentation" class="w-full mb-2 mt-3 border-t">
              </div>
              <div class="col-12">
                <p-table data-testid="customer-sales-table" [value]="salesData">
                  <ng-template #header>
                    <tr>
                      <th>
                        <div class="header-wr">
                          <span class="col-name">{{ 'CUSTOMER_SINGLE_VIEW.SERIAL' | translate }}</span>
                        </div>
                      </th>
                      <th>
                        <div class="header-wr">
                          <span class="col-name">{{ 'CUSTOMER_SINGLE_VIEW.SKU' | translate }}</span>
                        </div>
                      </th>
                      <th>
                        <div class="header-wr">
                          <span class="col-name">{{ 'CUSTOMER_SINGLE_VIEW.WARRANTY' | translate }}</span>
                        </div>
                      </th>
                      <th>
                        <div class="header-wr">
                          <span class="col-name">{{ 'CUSTOMER_SINGLE_VIEW.MARKET' | translate }}</span>
                        </div>
                      </th>
                      <th>
                        <div class="header-wr">
                          <span class="col-name">{{ 'CUSTOMER_SINGLE_VIEW.RETAILER' | translate }}</span>
                        </div>
                      </th>
                      <th>
                        <div class="header-wr">
                          {{ 'CUSTOMER_SINGLE_VIEW.SALE_ON' | translate }}
                        </div>
                      </th>
                      <th>
                        <div class="header-wr">
                          <span class="col-name">{{ 'CUSTOMER_SINGLE_VIEW.STATUS' | translate }}</span>
                        </div>
                      </th>
                    </tr>
                  </ng-template>
                  <ng-template #body let-sale>
                    <tr>
                      <td>
                        <span class="p-column-title">{{ 'CUSTOMER_SINGLE_VIEW.SERIAL' | translate }}:</span>
                        @if (sale.id && allowViewSale) {
                          <a [routerLink]="['/items/', sale.itemId]" class="inline-flex items-center link">{{ sale.itemSerialNumber }}</a>
                        } @else {
                          {{ sale.itemSerialNumber | defaultValue }}
                        }
                      </td>
                      <td>
                        <span class="p-column-title">{{ 'CUSTOMER_SINGLE_VIEW.SKU' | translate }}:</span>
                        @if (sale.id && allowViewSale) {
                          <a [routerLink]="['/products/', sale.productId]" class="inline-flex items-center link">
                            {{ sale.productSku }}
                          </a>
                        } @else {
                          {{ sale.productSku | defaultValue }}
                        }
                      </td>
                      <td>
                        <span class="p-column-title">{{ 'CUSTOMER_SINGLE_VIEW.WARRANTY' | translate }}:</span>
                        {{ sale.warrantyCode | defaultValue }}
                      </td>
                      <td>
                        <span class="p-column-title">{{ 'CUSTOMER_SINGLE_VIEW.MARKET' | translate }}:</span>
                        {{ sale.marketName | defaultValue }}
                      </td>
                      <td>
                        <span class="p-column-title">{{ 'CUSTOMER_SINGLE_VIEW.RETAILER' | translate }}:</span>
                        {{ sale.retailerName | defaultValue }}
                      </td>
                      <td>
                        <span class="p-column-title">{{ 'CUSTOMER_SINGLE_VIEW.SALE_ON' | translate }}:</span>
                        {{ sale.date | date: 'dd-MM-yyyy HH:mm' | defaultValue }}
                      </td>
                      <td>
                        <span class="p-column-title">{{ 'CUSTOMER_SINGLE_VIEW.STATUS' | translate }}:</span>
                        @if (!sale.isReturned) {
                          <span class="tag tag-green">
                            {{ 'ENUMS.ACTIVE' | translate }}
                          </span>
                        } @else {
                          <span class="tag tag-red">
                            {{ sale.status ?? ('ENUMS.RETURNED' | translate) }}
                          </span>
                        }
                      </td>
                    </tr>
                  </ng-template>
                  <ng-template #emptymessage>
                    <tr>
                      <td [attr.colspan]="7">{{ 'CUSTOMER_SINGLE_VIEW.NO_DATA' | translate }}</td>
                    </tr>
                  </ng-template>
                </p-table>

                <!-- Pagination -->
                <app-custom-paginator
                  data-testid="paginator"
                  [pageNumber]="pageNumber"
                  [rows]="pageSize"
                  [totalRecords]="totalRecords"
                  [rowsPerPageOptions]="[10, 20, 30]"
                  [showCurrentPageReport]="true"
                  [currentPageReportTemplate]="'PAGINATOR.CURRENT_PAGE_REPORT' | translate"
                  [disabled]="!salesData"
                  [alwaysShow]="true"
                  [showFirstLastIcon]="true"
                  [showPageLinks]="true"
                  [showPageSizeSelector]="true"
                  (onPageChange)="onPageChange($event)">
                </app-custom-paginator>

                <ng-template #noSales>
                  <p>{{ 'CUSTOMER_SINGLE_VIEW.NO_DATA' | translate }}</p>
                </ng-template>
              </div>
            </section>
            <!-- /main content -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Delete customer -->
<dialog-reason #dialog [title]="'MODALBOXES.TITLE_CONFIRM_DELETE_CUSTOMER'" (onClose)="deleteCustomer($event)"></dialog-reason>
